import { render, staticRenderFns } from "./OrganismRepository.vue?vue&type=template&id=71f9daf4&scoped=true&"
import script from "./OrganismRepository.vue?vue&type=script&lang=js&"
export * from "./OrganismRepository.vue?vue&type=script&lang=js&"
import style0 from "./OrganismRepository.vue?vue&type=style&index=0&id=71f9daf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9daf4",
  null
  
)

export default component.exports